import { Dict } from '../types/decorable';
import { SimpleHandler, DictHandler } from '../types/@types/sl-v-types';
import { v4 as uuid } from 'uuid';
import { EventEmitter } from '@angular/core';

export class InterruptableTimer {
  private args: Dict | null;
  private msecondsPerSample: number;
  private handler: SimpleHandler | DictHandler | null;
  private timerMSeconds: number;
  private sampling: boolean;
  private lastInterrupt = 0;
  private lastInterruptId;
  public wasRunning = false;
  public samples = new EventEmitter<any>();
  constructor(optMsecondsPerSample: number = 2500) {
    this.msecondsPerSample = optMsecondsPerSample;
    this.sampling = false;
  }
  get isSampling(): boolean {
    return this.sampling;
  }

  Start(handler?: DictHandler | SimpleHandler, optTimerMSeconds: number = NaN, optArgs: Dict | null = null) {
    if (!!handler) {
      this.handler = handler;
    }
    if (this.lastInterrupt !== 0) {
      if (optArgs !== null) {
        this.args = optArgs;
      }
      this.Interrupt(false);
      return;
    }
    this.wasRunning = false;

    this.timerMSeconds = isNaN(optTimerMSeconds) ? this.msecondsPerSample : optTimerMSeconds;
    this.msecondsPerSample = Math.min(this.timerMSeconds, this.msecondsPerSample);
    this.args = optArgs;
    this.Interrupt();
  }
  Stop(optTriggerHandler: boolean = false) {
    this.lastInterrupt = 0;
    this.wasRunning = true;
    if (optTriggerHandler === true) {
      this.handler(this.args);
    }
  }
  Cancel() {
    this.Stop(false);
    this.handler = () => { };
  }
  Interrupt(isNew: boolean = true) {
    if (isNew === true) {
      this.lastInterrupt = performance.now();
      this.lastInterruptId = uuid();
    }

    setTimeout(() => {

      if (this.lastInterrupt === 0) {
        return;
      }
      const id = this.lastInterruptId;
      if ((performance.now() - this.lastInterrupt) < this.timerMSeconds) {

        this.Interrupt(false);
      } else {
        const me = this;
        window.requestAnimationFrame(() => {
          if (id === this.lastInterruptId) {
            if (!!me.handler) {
              me.handler(this.args);
            }
          }

        });
        this.lastInterrupt = 0;
      }

    }, 10);
  }
}
